<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="my-3 flex flex-col md:flex-row gap-4 items-center">
  <div class="flex items-center gap-3 my-3">
    <app-back-option-section [loading]="loading"></app-back-option-section>
    <h2>Driver Details - {{driverData?.refNo}}</h2>
  </div>
  <div class="flex gap-3">
    <div *appHasAnyPrivilege="'DRIVER_UPDATE'">

      <nz-tag nz-popconfirm nzPopconfirmTitle="Are you sure you want to change the Active status to Inactive?"
              (nzOnConfirm)="changeStatus()" (nzOnCancel)="cancel()"
              *ngIf="driverData?.active"
              [nzColor]="'#3ab200'" class="rounded-full hover:cursor-pointer"
      >Active
      </nz-tag>
      <nz-tag nz-popconfirm nzPopconfirmTitle="Are you sure you want to change the Inactive status to Active?"
              (nzOnConfirm)="changeStatus()" (nzOnCancel)="cancel()"
              *ngIf="!driverData?.active"
              [nzColor]="'#F3454C'" class="rounded-full hover:cursor-pointer"
      >Inactive
      </nz-tag>
    </div>

    <div *ngIf="!hasPermission('DRIVER_UPDATE')">

      <nz-tag *ngIf="driverData?.active"
              [nzColor]="'#3ab200'" class="rounded-full"
      >Active
      </nz-tag>
      <nz-tag *ngIf="!driverData?.active"
              [nzColor]="'#F3454C'" class="rounded-full"
      >Inactive
      </nz-tag>
    </div>
  </div>
</div>

<nz-tabset>
  <nz-tab nzTitle="Driver Information">
    <div [ngClass]="!loading ? 'block' : 'hidden'">
      <section id="driverDetails">
        <nz-card class="mt-5">
          <div class="flex justify-between">
            <h5>Driver Details</h5>
            <button class="sm:block hidden" *appHasAnyPrivilege="'DRIVER_UPDATE'" nz-button nzType="primary"
                    (click)="goto()">Edit Details
            </button>
          </div>
          <div class="mt-3 grid lg:grid-cols-2 xl:grid-cols-3 gap-8">
            <div class="sub-section">
              <div class="item-row">
                <p class="subject-name">Segment</p>
                <p
                  class="subject-data">{{(driverData?.driverSegment === "OUTSOURCE_DRIVER") ? 'Outsourced Driver' : 'SR Driver'}}</p>
              </div>
              <div *ngIf="driverData?.driverSegment === 'OUTSOURCE_DRIVER'" class="item-row">
                <p class="subject-name">Supplier </p>
                <p class="subject-data"><a (click)="goto('supplier')">{{driverData?.supplierName}}</a></p>
              </div>
              <div class="item-row">
                <p class="subject-name">Can Drive </p>
                <div>
                  <div>
                    <p *ngFor="let can of driverData?.canDrive"
                       class="subject-data">{{can.checked && can.label === "Light Vehicles" ? 'Light Vehicles' : (can.checked && can.label === "Heavy Vehicles" ? 'Heavy Vehicles' : '')}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="sub-section">
              <div class="item-row">
                <p class="subject-name">Name </p>
                <p class="subject-data">{{driverData?.fullName}}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">NIC </p>
                <p class="subject-data">{{driverData?.nicNo}}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">Mobile Number </p>
                <p class="subject-data clickable-mail-phone_no"><a class="clickable-mail-phone_no" href="tel:{{driverData?.mobileNumber}}">{{driverData?.mobileNumber}}</a></p>
              </div>
              <div class="item-row">
                <p class="subject-name">Email </p>
                <p class="subject-data clickable-mail-phone_no"><a class="clickable-mail-phone_no" href="mailto:{{driverData?.email}}">{{driverData?.email}}</a></p>
              </div>
              <div class="item-row">
                <p class="subject-name">Registered/ Unregistered </p>
                <p class="subject-data">{{driverData?.isRegistered ? 'Registered' : 'Unregistered'}}</p>
              </div>
            </div>
            <div class="sub-section">
              <div class="item-row">
                <p class="subject-name">Last Transfer Date and Time </p>
                <p class="subject-data">To do</p>
              </div>
              <div class="item-row">
                <p class="subject-name">Last Transfer Completed Date and Time </p>
                <p class="subject-data">To do</p>
              </div>
              <div class="item-row">
                <p class="subject-name">Next Transfer Allocated Date and Time </p>
                <p class="subject-data">To do</p>
              </div>
            </div>
          </div>
        </nz-card>

        <nz-card class="mt-5">
          <h5>Language and License Information</h5>
          <div class="mt-5 grid lg:grid-cols-2 xl:grid-cols-3 gap-8">
            <div class="sub-section">
              <div class="item-row">
                <p class="subject-name">Languages</p>
                <div>
                  <div class="flex mb-1" *ngFor="let lan of driverData?.languageSkills">
                    <p class="subject-data">{{lan.language | titlecase}}
                      - {{lan.level | titlecase}}</p> <br>
                  </div>
                </div>
              </div>
              <!--          <div class="grid grid-cols-2 gap-auto">-->
              <!--            <div>-->
              <!--              <p class="font-normal" style="color: #6d6d6d">Registration Number </p>-->
              <!--            </div>-->
              <!--            <div>-->
              <!--              <p class="font-medium">Kasun Rajitha</p>-->
              <!--            </div>-->
              <!--          </div>-->
            </div>

            <div class="sub-section">
              <div class="item-row">
                <p class="subject-name">Driver License Expiry Date </p>
                <p
                  class="subject-data">{{driverData?.licenseDetails?.drivingLicenseExpiryDate | date: "dd-MM-y"}}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">Tourist Driver License </p>
                <p
                  class="subject-data">{{driverData?.licenseDetails?.hasTourDriverLicense ? (driverData?.licenseDetails?.tourDriverLicenseExpiryDate | date: 'dd-MM-y') : '-'}}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">Chauffeur Guide License </p>
                <p
                  class="subject-data">{{driverData?.licenseDetails?.hasChauffeurGuideLicense ? (driverData?.licenseDetails?.chauffeurGuideLicenseExpiryDate | date: 'dd-MM-y') : '-'}}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">National Guide License </p>
                <p
                  class="subject-data">{{driverData?.licenseDetails?.hasNationalGuideLicense ? (driverData?.licenseDetails?.nationalGuideLicenseExpiryDate | date: 'dd-MM-y') : '-'}}</p>
              </div>
            </div>

            <div class="sub-section">
              <p class="subject-name" style="color: #6d6d6d">Attachments</p>
              <p *ngIf="driverData?.licenseDetails?.attachments.length === 0"
                 class="subject-data">-</p>
              <div *ngIf="driverData?.licenseDetails?.attachments.length > 0" class="flex flex-col mt-2">
                <a *ngFor="let file of driverData?.licenseDetails?.attachments" href="{{file.url}}"
                   [nz-tooltip]="file.name"
                   target="_blank"><span nz-icon nzType="file" class="text-sm"
                                         nzTheme="outline"></span><span
                  class="ml-2 text-sm text-black"> - {{file.name}}</span></a>
              </div>
            </div>
          </div>
        </nz-card>


<!--        Removed below card as client request-->

<!--        <nz-card class="mt-5" *ngIf="(driverData?.driverSegment === 'OUTSOURCE_DRIVER' && !driverData?.isASupplier)">-->
<!--          <h5>Payment Details</h5>-->
<!--          <div class="mt-5 grid lg:grid-cols-2 xl:grid-cols-3 gap-8">-->
<!--            <div class="sub-section">-->
<!--              <div class="item-row">-->
<!--                <p class="subject-name">Bank Name</p>-->
<!--                <p class="subject-data">{{driverData?.paymentDetails?.bankName}}</p>-->
<!--              </div>-->
<!--              <div class="item-row">-->
<!--                <p class="subject-name">Branch Name </p>-->
<!--                <p class="subject-data">{{driverData?.paymentDetails?.branchName}}</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="sub-section">-->
<!--              <div class="item-row">-->
<!--                <p class="subject-name">Account Type</p>-->
<!--                <p class="subject-data">{{driverData?.paymentDetails?.accountType | titlecase}}</p>-->
<!--              </div>-->
<!--              <div class="item-row">-->
<!--                <p class="subject-name">Account Holder Name </p>-->
<!--                <p class="subject-data">{{driverData?.paymentDetails?.accountHolderName}}</p>-->
<!--              </div>-->
<!--              <div class="item-row">-->
<!--                <p class="subject-name">Account Number </p>-->
<!--                <p class="subject-data">{{driverData?.paymentDetails?.accountNumber}}</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="sub-section">-->
<!--              <div class="item-row">-->
<!--                <p class="subject-name">Attachments</p>-->
<!--                <p *ngIf="driverData?.paymentDetails?.attachments.length === 0"-->
<!--                   class="subject-data">-</p>-->
<!--                <div *ngIf="driverData?.paymentDetails?.attachments.length > 0" class="flex flex-col mt-2">-->
<!--                  <a *ngFor="let file of driverData?.paymentDetails?.attachments" href="{{file.url}}"-->
<!--                     [nz-tooltip]="file.name"-->
<!--                     target="_blank"><span nz-icon nzType="file" class="text-sm"-->
<!--                                           nzTheme="outline"></span><span-->
<!--                    class="ml-2 text-sm text-black"> - {{file.name}}</span></a>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </nz-card>-->

      </section>

      <section id="notesAndAttachments" class="mt-6">
        <nz-card>
          <div class="grid md:grid-cols-2 lg:grid-cols-2 gap-4">
            <div>
              <h5 class="mb-3">Notes</h5>
              <div class="">
                <div class="grid grid-cols-1 gap-auto">
                  <!--                  <div>-->
                  <!--                    <p class="font-normal" style="color: #6d6d6d">Model</p>-->
                  <!--                  </div>-->
                  <div>
                    <p class="font-medium text-justify">{{driverData?.notes}}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="sub-section">
              <h5 class="mb-3">Attachments</h5>
              <div class="">
                <div class="grid grid-cols-1 gap-auto">
                  <div>
                    <!--                    <p class="font-normal" style="color: #6d6d6d">Booking Number </p>-->
                  </div>
                  <div *ngIf="driverData?.attachments?.length === 0">
                    <p
                      class="font-medium">-</p>
                  </div>
                  <div *ngIf="driverData?.attachments?.length > 0" class="flex flex-col mt-2">
                    <a *ngFor="let file of driverData?.attachments" href="{{file.url}}"
                       [nz-tooltip]="file.name"
                       target="_blank"><span nz-icon nzType="file" class="text-sm"
                                             nzTheme="outline"></span><span
                      class="ml-2 text-sm text-black"> - {{file.name}}</span></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nz-card>
      </section>
    </div>

    <div [ngClass]="loading ? 'block' : 'hidden'">
      <app-single-view-skeleton-template [typeName]="'single-view'"></app-single-view-skeleton-template>
    </div>
  </nz-tab>

<!--  <nz-tab nzTitle="Vehicles">-->
<!--    <div [ngClass]="!loading ? 'block' : 'hidden'" class="rounded-lg">-->
<!--      <div style="background-color: #FAFAFA" class="hidden lg:grid grid-cols-6 p-4 rounded-t-lg">-->
<!--        <div class="flex flex-row justify-between items-center ">-->
<!--          <p class="font-medium mx-1">Vehicle No</p>-->
<!--          <nz-divider class="" [nzType]="'vertical'"></nz-divider>-->
<!--        </div>-->
<!--        <div class="flex flex-row justify-between items-center ">-->
<!--          <p class="font-medium mx-1">Vehicle Model</p>-->
<!--          <nz-divider class="" [nzType]="'vertical'"></nz-divider>-->
<!--        </div>-->
<!--        <div class="flex flex-row justify-between items-center ">-->
<!--          <p class="font-medium mx-1">Registration Number</p>-->
<!--          <nz-divider class="" [nzType]="'vertical'"></nz-divider>-->
<!--        </div>-->
<!--        <div class="flex flex-row justify-between items-center ">-->
<!--          <p class="font-medium mx-1">Year of Manufacture</p>-->
<!--          <nz-divider class="" [nzType]="'vertical'"></nz-divider>-->
<!--        </div>-->
<!--        <div class="flex flex-row justify-between items-center ">-->
<!--          <p class="font-medium mx-1">Added Date</p>-->
<!--          <nz-divider class="" [nzType]="'vertical'"></nz-divider>-->
<!--        </div>-->
<!--        <div *appHasAnyPrivilege="'DRIVER_UPDATE'" class="flex justify-center">-->
<!--          <p class="font-medium">Actions</p>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div *ngIf="driverData?.driverSegment === 'OUTSOURCE_DRIVER' && driverData?.vehicleDetails?.length > 0">-->
<!--        <div *ngFor="let vehi of driverData?.vehicleDetails; let i = index" class="flex flex-col py-2 px-4  bg-white">-->
<!--          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 p-4">-->
<!--            <div class="">-->
<!--              <p class="font-medium block lg:hidden">Vehicle No</p>-->
<!--              <p>VN0{{i + 1}}</p>-->
<!--            </div>-->
<!--            <div class="">-->
<!--              <p class="font-medium block lg:hidden">Vehicle Model</p>-->
<!--              <p>{{vehi.vehicleModel}}</p>-->
<!--            </div>-->
<!--            <div class="">-->
<!--              <p class="font-medium block lg:hidden">Registration Number</p>-->
<!--              <p>{{vehi.registerNumber}}</p>-->
<!--            </div>-->
<!--            <div class="">-->
<!--              <p class="font-medium block lg:hidden">Year of Manufacture</p>-->
<!--              <p>{{vehi.yearOfManufacture | date: 'dd-MM-y'}}</p>-->
<!--            </div>-->
<!--            <div class="">-->
<!--              <p class="font-medium block lg:hidden">Added Date</p>-->
<!--              <p>{{driverData.createdAt | date: 'dd-MM-y'}}</p>-->
<!--            </div>-->
<!--            <div *appHasAnyPrivilege="'DRIVER_UPDATE'"-->
<!--                 class="flex flex-row lg:flex-col lg:justify-center gap-3 lg:gap-0">-->
<!--              <div class="block lg:hidden">-->
<!--                <p class="font-medium">Actions</p>-->
<!--              </div>-->
<!--              <button class="outline-button"-->
<!--                      nz-button nzType="default" nz-popconfirm-->
<!--                      nzPopconfirmTitle="Are you sure you want to remove this vehicle?"-->
<!--                      (nzOnConfirm)="removeVehicleDetails(i)" (nzOnCancel)="cancel()">Remove-->
<!--              </button>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="grid md:grid-cols-4 lg:grid-cols-8 gap-4 content-end">-->
<!--            <div *ngFor="let image of vehi?.vehicleImages">-->
<!--              <div>-->
<!--                <div class="flex justify-center items-center bg-slate-100 w-full h-25 xl:h-25">-->
<!--                  <img class="w-full h-40 xl:h-40" src="{{getImage(image, image?.type)}}" alt="">-->
<!--                </div>-->
<!--                <div class="flex justify-center mt-2">-->
<!--                  <span style="color: #a2a2a2" class="text-center">{{image?.type | titlecase}}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <nz-divider class="my-4" [nzType]="'horizontal'"></nz-divider>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div *ngIf="driverData?.driverSegment === 'SR_DRIVER' && driverData?.assignsVehicles?.length > 0">-->
<!--        <div *ngFor="let vehi of driverData?.assignsVehicles; let i = index">-->
<!--          <div class="flex flex-col py-2 px-4 bg-white">-->
<!--            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 p-4">-->
<!--              <div>-->
<!--                <p class="font-medium block lg:hidden">Vehicle No</p>-->
<!--                <p>{{vehi?.refNo}}</p>-->
<!--              </div>-->
<!--              <div>-->
<!--                <p class="font-medium block lg:hidden">Vehicle Model</p>-->
<!--                <p>{{vehi?.model}}</p>-->
<!--              </div>-->
<!--              <div>-->
<!--                <p class="font-medium block lg:hidden">Registration Number</p>-->
<!--                <p>{{vehi?.ownershipDetails?.registrationNumber}}</p>-->
<!--              </div>-->
<!--              <div>-->
<!--                <p class="font-medium block lg:hidden">Year of Manufacture</p>-->
<!--                <p>{{vehi?.ownershipDetails?.issuedDate | date: 'dd-MM-y'}}</p>-->
<!--              </div>-->
<!--              <div>-->
<!--                <p class="font-medium block md:hidden">Added Date</p>-->
<!--                <p>{{vehi?.createdAt | date: 'dd-MM-y'}}</p>-->
<!--              </div>-->
<!--              <div *appHasAnyPrivilege="'DRIVER_UPDATE'"-->
<!--                   class="flex flex-row lg:flex-col lg:justify-center gap-3 lg:gap-0">-->
<!--                <div class="block lg:hidden">-->
<!--                  <p class="font-medium">Actions</p>-->
<!--                </div>-->
<!--                <button class="outline-button "-->
<!--                        nz-button nzType="default" nz-popconfirm-->
<!--                        nzPopconfirmTitle="Are you sure you want to remove this vehicle?"-->
<!--                        (nzOnConfirm)="removeAssignVehicleDetails(i)" (nzOnCancel)="cancel()">Remove-->
<!--                </button>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="grid md:grid-cols-4 lg:grid-cols-8 gap-4 content-end">-->
<!--              <div *ngFor="let img of vehi.vehicleImg">-->
<!--                <div>-->
<!--                  <div class="flex justify-center items-center bg-slate-100 w-full h-25 xl:h-25">-->
<!--                    <img class="w-full h-40 xl:h-40" [src]="img" alt="">-->
<!--                  </div>-->
<!--                  &lt;!&ndash;                <div class="flex justify-center mt-2">&ndash;&gt;-->
<!--                  &lt;!&ndash;                  <span style="color: #a2a2a2" class="text-center">Front</span>&ndash;&gt;-->
<!--                  &lt;!&ndash;                </div>&ndash;&gt;-->
<!--                </div>-->
<!--              </div>-->

<!--              &lt;!&ndash;              <div>&ndash;&gt;-->
<!--              &lt;!&ndash;                <div class="flex justify-center items-center bg-slate-100 w-full h-30 xl:h-30">&ndash;&gt;-->
<!--              &lt;!&ndash;                  <img class="w-full h-40 xl:h-40" src="assets/img/image-placeholder.png" alt="">&ndash;&gt;-->
<!--              &lt;!&ndash;                </div>&ndash;&gt;-->
<!--              &lt;!&ndash;                <div class="flex justify-center mt-2">&ndash;&gt;-->
<!--              &lt;!&ndash;                  <span style="color: #a2a2a2" class="text-center">Back</span>&ndash;&gt;-->
<!--              &lt;!&ndash;                </div>&ndash;&gt;-->
<!--              &lt;!&ndash;              </div>&ndash;&gt;-->

<!--              &lt;!&ndash;              <div>&ndash;&gt;-->
<!--              &lt;!&ndash;                <div class="flex justify-center items-center bg-slate-100 w-full h-30 xl:h-30">&ndash;&gt;-->
<!--              &lt;!&ndash;                  <img class="w-full h-40 xl:h-40" src="assets/img/image-placeholder.png" alt="">&ndash;&gt;-->
<!--              &lt;!&ndash;                </div>&ndash;&gt;-->
<!--              &lt;!&ndash;                <div class="flex justify-center mt-2">&ndash;&gt;-->
<!--              &lt;!&ndash;                  <span style="color: #a2a2a2" class="text-center">Left</span>&ndash;&gt;-->
<!--              &lt;!&ndash;                </div>&ndash;&gt;-->
<!--              &lt;!&ndash;              </div>&ndash;&gt;-->

<!--              &lt;!&ndash;              <div>&ndash;&gt;-->
<!--              &lt;!&ndash;                <div class="flex justify-center items-center bg-slate-100 w-full h-30 xl:h-30">&ndash;&gt;-->
<!--              &lt;!&ndash;                  <img class="w-full h-40 xl:h-40" src="assets/img/image-placeholder.png" alt="">&ndash;&gt;-->
<!--              &lt;!&ndash;                </div>&ndash;&gt;-->
<!--              &lt;!&ndash;                <div class="flex justify-center mt-2">&ndash;&gt;-->
<!--              &lt;!&ndash;                  <span style="color: #a2a2a2" class="text-center">Right</span>&ndash;&gt;-->
<!--              &lt;!&ndash;                </div>&ndash;&gt;-->
<!--              &lt;!&ndash;              </div>&ndash;&gt;-->

<!--              &lt;!&ndash;              <div>&ndash;&gt;-->
<!--              &lt;!&ndash;                <div class="flex justify-center items-center bg-slate-100 w-full h-30 xl:h-30">&ndash;&gt;-->
<!--              &lt;!&ndash;                  <img class="w-full h-40 xl:h-40" src="assets/img/image-placeholder.png" alt="">&ndash;&gt;-->
<!--              &lt;!&ndash;                </div>&ndash;&gt;-->
<!--              &lt;!&ndash;                <div class="flex justify-center mt-2">&ndash;&gt;-->
<!--              &lt;!&ndash;                  <span style="color: #a2a2a2" class="text-center">Boot</span>&ndash;&gt;-->
<!--              &lt;!&ndash;                </div>&ndash;&gt;-->
<!--              &lt;!&ndash;              </div>&ndash;&gt;-->

<!--              &lt;!&ndash;              <div>&ndash;&gt;-->
<!--              &lt;!&ndash;                <div class="flex justify-center items-center bg-slate-100 w-full h-30 xl:h-30">&ndash;&gt;-->
<!--              &lt;!&ndash;                  <img class="w-full h-40 xl:h-40" src="assets/img/image-placeholder.png" alt="">&ndash;&gt;-->
<!--              &lt;!&ndash;                </div>&ndash;&gt;-->
<!--              &lt;!&ndash;                <div class="flex justify-center mt-2">&ndash;&gt;-->
<!--              &lt;!&ndash;                  <span style="color: #a2a2a2" class="text-center">Dashboard</span>&ndash;&gt;-->
<!--              &lt;!&ndash;                </div>&ndash;&gt;-->
<!--              &lt;!&ndash;              </div>&ndash;&gt;-->

<!--              &lt;!&ndash;              <div>&ndash;&gt;-->
<!--              &lt;!&ndash;                <div class="flex justify-center items-center bg-slate-100 w-full h-30 xl:h-30">&ndash;&gt;-->
<!--              &lt;!&ndash;                  <img class="w-full h-40 xl:h-40" src="assets/img/image-placeholder.png" alt="">&ndash;&gt;-->
<!--              &lt;!&ndash;                </div>&ndash;&gt;-->
<!--              &lt;!&ndash;                <div class="flex justify-center mt-2">&ndash;&gt;-->
<!--              &lt;!&ndash;                  <span style="color: #a2a2a2" class="text-center">Interior Rear</span>&ndash;&gt;-->
<!--              &lt;!&ndash;                </div>&ndash;&gt;-->
<!--              &lt;!&ndash;              </div>&ndash;&gt;-->
<!--            </div>-->
<!--            <nz-divider class="my-4" [nzType]="'horizontal'"></nz-divider>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

<!--    <div [ngClass]="loading ? 'block' : 'hidden'">-->
<!--      <app-single-view-skeleton-template-->
<!--        [typeName]="'driver-single-view-vehicle-tab'"></app-single-view-skeleton-template>-->
<!--    </div>-->

<!--  </nz-tab>-->


  <nz-tab nzTitle="Tour Details" *appHasAnyPrivilege="'DRIVER_TOUR_DETAILS_VIEW'">

    <section class="my-3">

      <nz-card>
        <div class="flex flex-col gap-3">
          <div [ngClass]="loading ? 'hidden' : 'block'">
            <nz-collapse>
              <nz-collapse-panel [nzHeader]="'Advanced Search'">
                <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center md:items-end gap-4">
                  <div class="flex flex-col xl:flex-row xl:items-center gap-2 xl:gap-0">
                    <nz-input-group nzSearch [nzAddOnAfter]="suffixIconSearchButton" style="width: auto">
                      <input type="text" (keydown.enter)="search()" [(ngModel)]="searchText" nz-input placeholder="Search here"/>
                    </nz-input-group>

                    <ng-template #suffixIconSearchButton>
                      <button nz-button nzType="primary" nzSearch (click)="search()" class="bg-[#6B6C6E] border-[#6B6C6E]">
                        <span nz-icon nzType="search"></span>
                      </button>
                    </ng-template>

                    <nz-divider class="hidden lg:block" [nzType]="'vertical'"></nz-divider>

                    <div class="flex xl:w-auto  flex-col lg:flex-row lg:items-center">
                      <div>
                        <nz-form-label class="">Filter By Status</nz-form-label>
                      </div>

                      <div class="w-full">
                        <nz-select
                          [(ngModel)]="statusFilter"
                          (ngModelChange)="search()"
                          nzPlaceHolder="Select Status"
                          [nzAllowClear]="true"
                          class="w-full"
                        >
                          <nz-option nzLabel="Reservation" nzValue="RESERVATION"></nz-option>
                          <nz-option nzLabel="On Transfer" nzValue="ON_TRANSFER"></nz-option>
                          <nz-option nzLabel="On Rent" nzValue="ON_RENT"></nz-option>
                          <nz-option nzLabel="On Other Tour" nzValue="ON_OTHER_TOUR"></nz-option>
                          <nz-option nzLabel="Completed" nzValue="COMPLETED"></nz-option>
                          <nz-option nzLabel="Cancelled" nzValue="CANCELLED"></nz-option>
                        </nz-select>
                      </div>
                    </div>
                    <div>
                        <nz-divider class="hidden lg:block" [nzType]="'vertical'"></nz-divider>
                      </div>
                      <nz-range-picker [(ngModel)]="dateFilter" (ngModelChange)="onChangeDateFilter($event)"></nz-range-picker>
                    </div>
                  <div>
                    <button nz-button nzBlock class="outline-button" (click)="resetSearch()">
                      Reset All
                    </button>
                  </div>
                </div>
              </nz-collapse-panel>
            </nz-collapse>


          </div>

          <div [ngClass]="loading ? 'hidden' : 'block'" class="table-card mt-4">
            <div class="table-obj">
              <nz-table
                #basicTable [nzData]="bookingData" [nzShowSizeChanger]="pageSize.length > 5"
                [nzPageSizeOptions]="pageSize.pageSizeOptions" [nzPageSize]="pageSize.pageSize"
                [nzPageIndex]="pageSize.pageIndex" [nzFrontPagination]="false" [nzTotal]="pageSize.length"
                (nzQueryParams)="onTableParamsChange($event)" nzTableLayout="fixed" [nzScroll]="{ x: 'auto' }"
                nzOuterBordered class="table-wSpace-nowrap"
              >
                <thead>
                <tr>
                  <th>Booking ID</th>
                  <th>Booking Type</th>
                  <th class="min-w-[180px]">Booking Start Date and Time</th>
                  <th class="min-w-[180px]">Booking End Date and Time</th>
                  <th>Booking Status</th>
                  <th class="min-w-[180px]">Vehicle Reg Number</th>
                  <th class="min-w-[180px]">Agent</th>
                  <th class="min-w-[180px]">Customer Name</th>
                </tr>

                </thead>
                <tbody>
                <ng-container
                  *ngFor="let data of basicTable.data"
                  class="align-baseline"
                >

                <tr>
                  <td>
                    <span  (click)="navigate(data)" class="clickable-element" *ngIf="data.bookingType === 'transfer'">{{data.transferId}}</span>
                    <span  (click)="navigate(data)" class="clickable-element" *ngIf="data.bookingType === 'rent'">{{data.refNo}}</span>
                    <span  (click)="navigate(data)" class="clickable-element" *ngIf="data.bookingType === 'other'">{{data.otherBookingId}}</span>
                  </td>
                  <td *ngIf="data.bookingType === 'rent'">Rent</td>
                  <td *ngIf="data.bookingType === 'transfer'">Transfer</td>
                  <td *ngIf="data.bookingType === 'other'">Other</td>

                  <td *ngIf="data.bookingType === 'rent'">{{ data.tourDetails.arrivalInformation ? (data.tourDetails.arrivalInformation.arrivalDate | date:'yyyy-MM-dd') + ' | ' + (data.tourDetails.arrivalInformation.arrivalTime | date:'hh:mm a') : '-' }}</td>
                  <td *ngIf="data.bookingType === 'transfer' && data.bookingDetails.bookingCategory === 'Arrival' ">{{ data.tourDetails.arrivalFlightDate ? (data.tourDetails.arrivalFlightDate | date:'yyyy-MM-dd') + ' | ' + (data.tourDetails.pickUpTime | date:'hh:mm a') : '-' }}</td>
                  <td *ngIf="data.bookingType === 'transfer' && data.bookingDetails.bookingCategory === 'Departure'">{{ data.tourDetails.departureTourDetails.departureFlightDate ? (data.tourDetails.departureTourDetails.departureFlightDate | date:'yyyy-MM-dd') + ' | ' + (data.tourDetails.departureTourDetails.departurePickUpTime | date:'hh:mm a') : '-' }}</td>
                  <td *ngIf="data.bookingType === 'other'">{{ data.reservationDetails.arrivalDate ? (data.reservationDetails.arrivalDate | date:'yyyy-MM-dd') + ' | ' + (data.reservationDetails.arrivalTime | date:'hh:mm a') : '-' }}</td>

                  <td *ngIf="data.bookingType === 'rent'">{{ data.tourDetails.departureInformation ? (data.tourDetails.departureInformation.departureDate | date:'yyyy-MM-dd') + ' | ' + (data.tourDetails.departureInformation.departureDate | date:'hh:mm a') : '-' }}</td>
                  <td *ngIf="data.bookingType === 'transfer' && data.bookingDetails.bookingCategory === 'Departure'">{{ data.tourDetails.departureTourDetails.departureEndDate ? (data.tourDetails.departureTourDetails.departureEndDate | date:'yyyy-MM-dd') + ' | ' + (data.tourDetails.departureTourDetails.departureEndTime | date:'hh:mm a') : '-' }}</td>
                  <td *ngIf="data.bookingType === 'transfer' && data.bookingDetails.bookingCategory === 'Arrival' ">{{ data.tourDetails.arrivalEndDate ? (data.tourDetails.arrivalEndDate | date:'yyyy-MM-dd') + ' | ' + (data.tourDetails.arrivalEndTime | date:'hh:mm a') : '-' }}</td>
                  <td *ngIf="data.bookingType === 'other'">{{ data.reservationDetails.departureDate ? (data.reservationDetails.departureDate | date:'yyyy-MM-dd') + ' | ' + (data.reservationDetails.departureTime | date:'hh:mm a') : '-' }}</td>



                  <td>
                    <nz-tag *ngIf="(data.bookingType !== 'transfer' && data?.status === 'COMPLETED') ||
                    (data.bookingType === 'transfer' && data?.arrivalDetails.status === 'COMPLETED' && data.bookingDetails.bookingCategory === 'Arrival') ||
                     (data.bookingType === 'transfer' && data?.departureDetails.status === 'COMPLETED' && data.bookingDetails.bookingCategory === 'Departure')" [nzColor]="'#3ab200'"
                            class="rounded-full"
                    >Completed
                    </nz-tag
                    >
                    <nz-tag
                      *ngIf="(data.bookingType !== 'transfer' && data?.status === 'CANCELLED') ||
                    (data.bookingType === 'transfer' && data?.arrivalDetails.status === 'CANCELLED' && data.bookingDetails.bookingCategory === 'Arrival') ||
                     (data.bookingType === 'transfer' && data?.departureDetails.status === 'CANCELLED' && data.bookingDetails.bookingCategory === 'Departure')"
                    class="rounded-full" [nzColor]="'#F3454C'"
                    >Cancelled
                    </nz-tag>
                    <nz-tag
                      *ngIf="(data.bookingType !== 'transfer' && data?.status === 'RESERVATION') ||
                    (data.bookingType === 'transfer' && data?.arrivalDetails.status === 'RESERVATION' && data.bookingDetails.bookingCategory === 'Arrival') ||
                     (data.bookingType === 'transfer' && data?.departureDetails.status === 'RESERVATION' && data.bookingDetails.bookingCategory === 'Departure')"
                      [nzColor]="'#FF8C00'" class="rounded-full"
                    >Reservation
                    </nz-tag>
                    <nz-tag
                      *ngIf="(data.bookingType !== 'transfer' && data?.status === 'ON_RENT') ||
                    (data.bookingType === 'transfer' && data?.arrivalDetails.status === 'ON_RENT' && data.bookingDetails.bookingCategory === 'Arrival') ||
                     (data.bookingType === 'transfer' && data?.departureDetails.status === 'ON_RENT' && data.bookingDetails.bookingCategory === 'Departure')"
                      [nzColor]="'#4655f5'" class="rounded-full"
                    >On Rent
                    </nz-tag>
                    <nz-tag
                      *ngIf="(data.bookingType !== 'transfer' && data?.status === 'ON_TRANSFER') ||
                    (data.bookingType === 'transfer' && data?.arrivalDetails.status === 'ON_TRANSFER' && data.bookingDetails.bookingCategory === 'Arrival') ||
                     (data.bookingType === 'transfer' && data?.departureDetails.status === 'ON_TRANSFER' && data.bookingDetails.bookingCategory === 'Departure')"
                      [nzColor]="'#4655f5'" class="rounded-full"
                    >On Transfer
                    </nz-tag>
                    <nz-tag
                      *ngIf="(data.bookingType !== 'transfer' && data?.status === 'ON_OTHER_TOUR') ||
                    (data.bookingType === 'transfer' && data?.arrivalDetails.status === 'ON_OTHER_TOUR' && data.bookingDetails.bookingCategory === 'Arrival') ||
                     (data.bookingType === 'transfer' && data?.departureDetails.status === 'ON_OTHER_TOUR' && data.bookingDetails.bookingCategory === 'Departure')"
                      [nzColor]="'#4655f5'" class="rounded-full"
                    >On Other Tour
                    </nz-tag>
                  </td>
                  <td *ngIf="data.bookingType === 'transfer' && data.departureDetails.allocateVehicle && data.bookingDetails.bookingCategory === 'Departure'">{{data.departureDetails?.allocateVehicle?.vehicleDetails?.registrationNumber}}</td>
                  <td *ngIf="data.bookingType === 'transfer' && data.departureDetails.allocatedVehicle && data.bookingDetails.bookingCategory === 'Departure'">{{data.departureDetails?.allocatedVehicle?.vehicleDetails?.registrationNumber}}</td>
                  <td *ngIf="data.bookingType === 'transfer' && data.arrivalDetails.allocateVehicle">{{data.arrivalDetails?.allocateVehicle?.vehicleDetails?.registrationNumber}}</td>
                  <td *ngIf="data.bookingType === 'transfer' && data.arrivalDetails.allocatedVehicle ">{{data.arrivalDetails?.allocatedVehicle?.vehicleDetails?.registrationNumber}}</td>
                  <td *ngIf="data.bookingType === 'transfer' && !data.departureDetails.allocateVehicle && !data.arrivalDetails.allocatedVehicle && !data.departureDetails.allocatedVehicle && !data.arrivalDetails.allocateVehicle">-</td>
                  <td *ngIf="data.bookingType === 'rent' && data.allocationDetails.allocatedVehicle ">{{data.allocationDetails.allocatedVehicle.vehicleDetails.registrationNumber}}</td>
                  <td *ngIf="data.bookingType === 'rent' && data.allocationDetails.allocatedDriverVehicle ">{{data.allocationDetails.allocatedDriverVehicle.vehicleDetails.registrationNumber}}</td>
                  <td *ngIf="data.bookingType === 'rent' && (!data.allocationDetails.allocatedDriverVehicle && !data.allocationDetails.allocatedVehicle) ">-</td>
                  <td *ngIf="data.bookingType === 'other' && data.allocationDetails.allocatedVehicle ">{{data.allocationDetails.allocatedVehicle.vehicleDetails.registrationNumber}}</td>
                  <td *ngIf="data.bookingType === 'other' && data.allocationDetails.allocatedDriverVehicle ">-</td>

                  <td *ngIf="data.bookingType === 'transfer'" (click)="nav(data.bookingDetails.agent._id, 'agent')">{{ data.bookingDetails.agent?.name || '-' }}</td>
                  <td *ngIf="data.bookingType === 'rent'" (click)="nav(data.bookingDetails.agent._id, 'agent')">{{ data.bookingDetails.agent?.name || '-' }}</td>
                  <td *ngIf="data.bookingType === 'other'">-</td>

                  <td *ngIf="data.bookingType === 'transfer'" (click)="nav(data.tourDetails.customer._id, 'customer')">{{ data.tourDetails?.customer ?  data.tourDetails?.customer?.renterDetails?.fullName  : '-' }}</td>
                  <td *ngIf="data.bookingType === 'rent'" (click)="nav(data.customerDetails.customer._id, 'customer')">{{ data.customerDetails?.customer ?  data.customerDetails?.customer?.renterDetails?.fullName  : '-' }}</td>
                  <td *ngIf="data.bookingType === 'other'" >-</td>
                </tr>
                  <ng-container
                    *ngIf="data.bookingType === 'transfer' && (data.bookingDetails.bookingCategory === 'Arrival' && data.tourDetails.departureCheck)">

                    <tr>
                      <td>
                        <span  (click)="navigate(data)" class="clickable-element" *ngIf="data.bookingType === 'transfer'">{{data.transferId}}</span>
                       </td>
                      <td *ngIf="data.bookingType === 'transfer'">Transfer</td>


                      <td *ngIf="data.bookingType === 'transfer'">{{ data.tourDetails.departureTourDetails.departureFlightDate ? (data.tourDetails.departureTourDetails.departureFlightDate | date:'yyyy-MM-dd') + ' | ' + (data.tourDetails.departureTourDetails.departurePickUpTime | date:'hh:mm a') : '-' }}</td>

                      <td *ngIf="data.bookingType === 'transfer'">{{ data.tourDetails.departureTourDetails.departureEndDate ? (data.tourDetails.departureTourDetails.departureEndDate | date:'yyyy-MM-dd') + ' | ' + (data.tourDetails.departureTourDetails.departureEndTime | date:'hh:mm a') : '-' }}</td>



                      <td>
                        <nz-tag *ngIf="data?.departureDetails.status === 'COMPLETED'" [nzColor]="'#3ab200'"
                                class="rounded-full"
                        >Completed
                        </nz-tag
                        >
                        <nz-tag
                          *ngIf="data?.departureDetails.status === 'CANCELLED'" class="rounded-full" [nzColor]="'#F3454C'"
                        >Cancelled
                        </nz-tag>
                        <nz-tag
                          *ngIf="data?.departureDetails.status === 'RESERVATION'"
                          [nzColor]="'#FF8C00'" class="rounded-full"
                        >Reservation
                        </nz-tag>
                        <nz-tag
                          *ngIf="data?.departureDetails.status === 'ON_RENT'"
                          [nzColor]="'#4655f5'" class="rounded-full"
                        >On Rent
                        </nz-tag>
                        <nz-tag
                          *ngIf="data?.departureDetails.status === 'ON_TRANSFER' "
                          [nzColor]="'#4655f5'" class="rounded-full"
                        >On Transfer
                        </nz-tag>
                        <nz-tag
                          *ngIf="data?.departureDetails.status === 'ON_OTHER_TOUR' "
                          [nzColor]="'#4655f5'" class="rounded-full"
                        >On Other Tour
                        </nz-tag>
                      </td>
                      <td *ngIf="data.bookingType === 'transfer' && data.departureDetails.allocateVehicle">{{data.departureDetails?.allocateVehicle?.vehicleDetails?.registrationNumber}}</td>
                      <td *ngIf="data.bookingType === 'transfer' && data.departureDetails.allocatedVehicle">{{data.departureDetails?.allocatedVehicle?.vehicleDetails?.registrationNumber}}</td>
                      <td *ngIf="data.bookingType === 'transfer' && !data.departureDetails.allocateVehicle && !data.arrivalDetails.allocatedVehicle && !data.departureDetails.allocatedVehicle && !data.arrivalDetails.allocateVehicle">-</td>

                      <td *ngIf="data.bookingType === 'transfer'" (click)="nav(data.bookingDetails.agent._id, 'agent')">{{ data.bookingDetails.agent?.name || '-' }}</td>
                      <td *ngIf="data.bookingType === 'transfer'" (click)="nav(data.tourDetails.customer._id, 'customer')">{{ data.tourDetails?.customer ?  data.tourDetails?.customer?.renterDetails?.fullName  : '-' }}</td>
                    </tr>

                  </ng-container>
                </ng-container>

                </tbody>
              </nz-table>
            </div>
          </div>
          <div [ngClass]="loading ? 'block' : 'hidden'">
            <app-table-skeleton-template [columnData]="skeletonTableColumns"></app-table-skeleton-template>
          </div>



        </div>
      </nz-card>
    </section>



  </nz-tab>

</nz-tabset>

<app-single-view-supplier-popup *ngIf="isVisibleSupplier" [supplierId]="supplierId" [isVisible]="isVisibleSupplier"
                                (viewSupplierOnchange)="visibleSupplierOnchange($event)"></app-single-view-supplier-popup>
